import type { GetSensorsResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const sensorsActions = {
	getSensors: createActionSet<void, GetSensorsResponse.AsObject>("sensors/get"),
};
